import {Component, OnInit} from '@angular/core';
import {InputTextModule} from "primeng/inputtext";
import {DropdownModule} from "primeng/dropdown";
import {AdminTemplateComponent} from "../admin-template/admin-template.component";
import {FormsModule} from "@angular/forms";
import {Pages} from "../../dto/Pages";
import {NumberTextPipe} from "../../pips/number-text.pipe";
import {DialogModule} from "primeng/dialog";
import {ImageManagerComponent} from "../componnts/image-manager/image-manager.component";
import {UploadFile} from "../../dto/UploadFile";
import {SectionItem} from "../../dto/SectionItem";
import {KeyValue, KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {ButtonModule} from "primeng/button";
import {Setting} from "../../dto/Setting";
import {AccordionModule} from "primeng/accordion";
import {InputSwitchModule} from "primeng/inputswitch";

@Component({
    selector: 'app-admin-main-page',
    standalone: true,
    imports: [
        InputTextModule,
        DropdownModule,
        FormsModule,
        NumberTextPipe,
        DialogModule,
        ImageManagerComponent,
        NgIf,
        ButtonModule,
        NgForOf,
        KeyValuePipe,
        AccordionModule,
        InputSwitchModule
    ],
    templateUrl: './admin-main-page.component.html',
    styleUrl: './admin-main-page.component.css'
})
export class AdminMainPageComponent extends AdminTemplateComponent implements OnInit {
    selectedSetting: Setting = new Setting();
    mainPageConfig = {
        'top-bar': {
            'text': '',
            'page': null
        },
        'title-section': {
            'text1': ''
        },
        'business-bar': [],
        'abstract-bar': [],
        'brands': [],
        'success_stories': {
            'title':''
        },
        'service_features': {
            'title':''
        },
        'developer-bar': {
            'title':'',
            'text':'',
            'url':'',
            'img-uid': '',
        },
        'performance-bar': {
            'title':'',
            'text':'',
            'url':''
        },
        'footer': [],
        'bottom-bar': {},
        'copyright': {},
        'social-networks': [],
        'active-items': {'brands':true,"SuccessStories":true,"ServiceFeatures":true}
    };
    pageList: Array<Pages> = new Array<Pages>();
    displayImageCenter: boolean = false;
    imgManagerTemp: UploadFile = new UploadFile();
    selectPhotoType: string = "BusinessBar";
    newBusiness = {
        'page': null,
        'c-img-uid': '',
        'w-img-uid': '',
        'img-name': ''
    }
    newAbstract = {
        'text': '',
        'img-uid': '',
        'img-name': ''
    }
    newBrand = {
        'img-uid': '',
        'img-name': ''
    }
    newSocial={'url':'','type':''}
    newfooterCategory: string = "";
    newfooterLinkTitle: string[] = [];
    newfooterLinkPath: string[] = [];
    editorOptions = {theme: 'vs-dark', language: 'html'};

    ngOnInit() {
        this.checkLogin();
        this.fillSelectPage(null);
        this.loadMainPage()

    }
    ngAfterContentInit(): void {
        document.getElementById("center").onscroll = function (event) {
            let navbar = document.getElementById("savePnl");
            let sticky = navbar.offsetTop;
            // @ts-ignore
            if (event.target.scrollTop > sticky) {
                navbar.classList.add("sticky-header")
            } else {
                navbar.classList.remove("sticky-header");
            }
        };
    }



    fillSelectPage(event) {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/page/get_select_list?" +
            "page=0" +
            "&nrpp=50" +
            (event != null ? "&name=" + event.query : "")
        );
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.pageList = res["entity"];
                }
                if (res["status"] == 401) {
                    this.gotoLogin();
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }

    selectPhotoItem(uploadFile: UploadFile) {
        if (this.selectPhotoType == "BusinessBar1") {
            this.newBusiness["c-img-uid"] = uploadFile.uid
            this.newBusiness["img-name"] = uploadFile.name

        } else  if (this.selectPhotoType == "BusinessBar2") {
            this.newBusiness["w-img-uid"] = uploadFile.uid
            this.newBusiness["img-name"] = uploadFile.name

        } else if (this.selectPhotoType == "AbstractBar") {
            this.newAbstract["img-uid"] = uploadFile.uid
            this.newAbstract["img-name"] = uploadFile.name

        }else if (this.selectPhotoType == "Brands1") {
            this.newBrand["img-uid"] = uploadFile.uid
            this.newBrand["img-name"] = uploadFile.name

        }else if (this.selectPhotoType == "DeveloperBar") {
            this.mainPageConfig["developer-bar"]["img-uid"] = uploadFile.uid

        }
        this.displayImageCenter = false;




    }


    addBusinessLogoImage(type) {
        this.selectPhotoType = "BusinessBar"+type;
        this.displayImageCenter = true;
    }
    addBrandLogoImage(type) {
        this.selectPhotoType = "Brands"+type;
        this.displayImageCenter = true;
    }

    addToBusnessBarList() {
        this.mainPageConfig["business-bar"].push(this.newBusiness);
        this.newBusiness = {
            'page': null,
            'c-img-uid': '',
            'w-img-uid': '',
            'img-name': ''
        };
    }
    addToBrandList() {
        if(this.mainPageConfig["brands"]==null){
            this.mainPageConfig["brands"]=[];
        }
        this.mainPageConfig["brands"].push(this.newBrand);
        this.newBrand = {
            'img-uid': '',
            'img-name': ''
        };
    }

    removeFromBusinessList(busi: any) {
        this.mainPageConfig["business-bar"] = this.mainPageConfig["business-bar"].filter(b => b != busi);
    }
    removeFromBrandList(brand: any) {
        this.mainPageConfig["brands"] = this.mainPageConfig["brands"].filter(b => b != brand);
    }

    addAbstractLogoImage() {
        this.selectPhotoType = "AbstractBar";
        this.displayImageCenter = true;
    }

    addToAbstractList() {
        this.mainPageConfig["abstract-bar"].push(this.newAbstract);
        this.newAbstract = {
            'text': '',
            'img-uid': '',
            'img-name': ''
        };
    }
    addDeveloperImage() {
        this.selectPhotoType = "DeveloperBar";
        this.displayImageCenter = true;
    }

    removeFromAbstractList(abstract: any) {
        this.mainPageConfig["abstract-bar"] = this.mainPageConfig["abstract-bar"].filter(a => a != abstract);
    }

    addFooterCategory() {
        this.mainPageConfig["footer"].push({"name":this.newfooterCategory,"links":[]});
        // link["priority"] = p;
        this.newfooterCategory = "";



    }

    removeCategory(category: any) {
        this.mainPageConfig["footer"] = this.mainPageConfig["footer"].filter(c=>c!=category);
    }
    addFooterCatLink(category: any) {
        let link = {};
        link["title"] = this.newfooterLinkTitle[category.name];
        link["path"] = this.newfooterLinkPath[category.name];
        let temp = category['links'].find(l=>l['title'] == link["title"]);
        if(temp == null) {
            category['links'].push(link);
        }else {
            temp["path"] = this.newfooterLinkPath[category.name];
        }
        this.newfooterLinkTitle = [];
        this.newfooterLinkPath = [];

    }
    removeFromFooterCatLink(category: any,linkTitle){
        category['links'] = category['links'].filter(l=>l['title'] != linkTitle);
    }
    editFromFooterCatLink(category: any,linkTitle,linkPath){
        // category.value = category.value.filter(l=>l['title'] != linkTitle);
        this.newfooterLinkTitle[category.name] = linkTitle;
        this.newfooterLinkPath[category.name] = linkPath;
    }

    loadMainPage() {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/setting/get_setting?" +
            "&type=MAIN_PAGE");
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.selectedSetting = res["entity"];
                    this.mainPageConfig = JSON.parse(this.selectedSetting.data);
                    if(this.mainPageConfig.success_stories==null)
                        this.mainPageConfig.success_stories={"title":""};
                    if(this.mainPageConfig.service_features==null)
                        this.mainPageConfig.service_features={"title":""};
                    if(this.mainPageConfig["social-networks"]==null){
                        this.mainPageConfig["social-networks"]=[];
                        this.mainPageConfig["social-networks"].push(this.newSocial);
                    }


                    Object.values(this.mainPageConfig["footer"]).sort(([k1], [k2]) => k1.localeCompare(k2))
                }
                if (res["status"] == 401) {
                    this.gotoLogin();
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }

    saveMainPage() {
        let params = {};
        this.selectedSetting.data = JSON.stringify(this.mainPageConfig);
        console.log(this.selectedSetting.data);

        this.selectedSetting.type = "MAIN_PAGE";
        let body = this.selectedSetting;
        this.global.progressBar = true;
        var observable = this.restBack.doPost("lnd/setting/save_setting", body, params);
        observable.then((res: string) => {
                if (res["status"] == 200) {
                    let o = res["entity"];
                    // this.loadIndexData(null);

                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'info',
                        summary: $localize`:@@Save_Success:Save Success`,
                        detail: $localize`:@@Save_Success_Det:Save_Success_Det`
                    });


                } else if (res["status"] == 400) {

                } else if (res["status"] == 401) {

                }
                return res;
            },
            error => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            }).finally(() => {
            this.global.progressBar = false;


        });
    }

    selectBusnessPage() {
        let page:Pages = this.newBusiness['page'];
        this.newBusiness['c-img-uid'] = page.style.logoImage;
        this.newBusiness['w-img-uid']= page.style.w_logo_image;
        this.newBusiness['img-name']= page.name;
    }


    addSocialNetwork() {
        this.newSocial={'url':'','type':''};
        this.mainPageConfig["social-networks"].push(this.newSocial);

    }
}
